import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { SECURITY_DASHBOARD_RAIL_WIDTH } from './useSecurityDashboardGrid';

/** Shared flex gap (theme spacing 2 = 16px). */
export const SECURITY_DASHBOARD_FLEX_GAP = 2;

/** Horizontal module row — wraps on narrow viewports. */
export const securityDashboardFlexRowSx = (wrap: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexWrap: wrap ? 'wrap' : 'nowrap',
  gap: SECURITY_DASHBOARD_FLEX_GAP,
  alignItems: 'stretch',
  minWidth: 0,
});

/** Primary column that grows when siblings are permission-gated away. */
export const securityDashboardFlexGrowSx: SxProps<Theme> = {
  flex: '1 1 0',
  minWidth: 0,
};

/** Fixed-width right rail when paired; full width when alone or stacked. */
export const securityDashboardFlexRailSx = (
  stacked: boolean,
  paired: boolean,
): SxProps<Theme> => ({
  flex:
    stacked || !paired
      ? '1 1 100%'
      : `0 0 ${SECURITY_DASHBOARD_RAIL_WIDTH}px`,
  minWidth: 0,
});

/** ~50% width table/chart slot in a wrapping main area. */
export const securityDashboardFlexHalfSx = (stacked: boolean): SxProps<Theme> => ({
  flex: stacked ? '1 1 100%' : '1 1 calc(50% - 8px)',
  minWidth: stacked ? 0 : 280,
});

/** Full-width slot when a row has a single visible module. */
export const securityDashboardFlexFullSx: SxProps<Theme> = {
  flex: '1 1 100%',
  minWidth: 0,
};

/** @deprecated Use flex helpers — kept for card height/minWidth only. */
export const getDashboardPortfolioCardStyle = (
  _hasPortfolio: boolean,
  _hasSecurityScore: boolean,
  _isStacked: boolean,
  _isTablet: boolean,
): CSSProperties => ({
  minWidth: 0,
  height: '100%',
});

/** @deprecated Use flex helpers — kept for card height/minWidth only. */
export const getDashboardSecurityScoreStyle = (
  _hasPortfolio: boolean,
  _hasSecurityScore: boolean,
  _isStacked: boolean,
  _isTablet: boolean,
): CSSProperties => ({
  height: '100%',
  minWidth: 0,
});
